import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_BlockListSetup } from "../../shared/data.service";
import { StationBlockAlertAssignRequest } from "../../shared/station-block-alert-assign-request";

@Component({
	selector: "app-sbassignment-add-homeroom",
	templateUrl: "./sbassignment-add-homeroom.component.html",
	styleUrls: ["./sbassignment-add-homeroom.component.css"],
})
export class SBAssignmentAddHomeroomComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private dataService: DataService_BlockListSetup,
		private confirmationService: ConfirmationService
	) {}
	ngOnInit(): void {
		this.SelectedStationBlockAlert = this.dialogConfig.data.SelectedStationBlockAlert;
		this.SchoolID = this.SelectedStationBlockAlert.SchoolID;

		this.loadTable();
	}

	///////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////

	SelectedStationBlockAlert: any;
	SchoolID: number = -1;

	TableLoading: boolean = false;
	lstSelected: any = [];
	lstTable: any = [];
	pagerows: any = 10;
	pagefirst: any = 0;

	Processing: boolean = false;
	errorMessage: string = "";
	warningMessage: string = "";

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////

	loadTable() {
		this.errorMessage = "";
		this.TableLoading = true;

		var result = this.dataService.SBAInsertHomeroomSelectList(this.SchoolID, this.SelectedStationBlockAlert.StationBlockAlertID);
		result.subscribe(
			(response) => {
				this.lstTable = response;

				if (this.lstTable.length == 0) {
					this.warningMessage = "School doens't have any more homerooms that can be assigned.";
				}

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		if (this.lstSelected.length == 0) {
			this.errorMessage = "Select Homerooms to Assign";
			return;
		}

		this.Processing = true;

		var lstPIDs: number[] = [];
		var lstGIDs: number[] = [];
		var lstHIDs: number[] = [];

		lstHIDs = this.lstSelected.map((item: any) => item.HomeroomID);

		var parms: StationBlockAlertAssignRequest = {
			StationBlockAlertID: this.SelectedStationBlockAlert.StationBlockAlertID,
			lstPersonID: lstPIDs,
			lstGroupID: lstGIDs,
			lstHomeroomID: lstHIDs,
		};

		var result = this.dataService.StationBlockAlertAssign(parms);
		result.subscribe(
			(response: any) => {
				if (response.Status == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "stationblockalertassignmenthomeroom",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Homerooms were added successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "stationblockalertassignmenthomeroom",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add Homerooms: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////////
	onRowSelect(val) {
		this.errorMessage = "";
	}
	onRowUnselect(val) {
		this.errorMessage = "";
	}
	///////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}

	///////////////////////////////////////////////////////////
}
